import { createTheme } from '@mui/material/styles';
import { 
  Typography,
  Box,
  Button,
  Paper
} from '@mui/material';
import { styled } from '@mui/system';
import ActivePanelImage from '../assets/active-panel.png';

// テーマの作成
export const theme = createTheme({
  typography: {
    fontFamily: [
      'Noto Sans JP',
      'sans-serif'
    ].join(','),
  },
});

// 共通のカラーコードを定義
export const colors = {
  mainColor: '#232e3e',
  backGroundColor: '#F6F6F6',
  // グラデーションカラー
  gradientColor: 'linear-gradient(45deg, #FF4081 30%, #FF8E53 90%)',
  red: '#FF4081'
}

// 赤から黄色のメインカラー定義
export const GradientText = styled(Typography)({
  background: colors.gradientColor,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 'bold',
});

// 背景をぼかす
export const BlurBackground = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backdropFilter: 'blur(5px)',
  zIndex: 1200,
});

// FooodSmart用カラーのボタン
export const StyledButton = styled(Button)({
  marginTop: 15,
  height: 48,
  backgroundImage: `url(${ActivePanelImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  fontSize: 15,
  '&:hover': {
    opacity: 0.8,
  },
});

// ログインフォーム類の枠用スタイル
export const StyledPaper = styled(Paper)({
  marginTop: 20,
  marginLeft: 10,
  marginRight: 10,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'background.paper',
  padding: 20,
  borderRadius: 2,
  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  backdropFilter: 'blur(10px)',
});
